export default {
  introSteps: {
    exportFile: 'Exporte o inventário sem dados do outro servidor Arena (por ex. Dev ou QA)',
    selectFile:
      'Selecione o arquivo exportado (.zip): ele é comparado com este inventário e as diferenças são exibidas',
    applyChanges:
      'Revise as diferenças e aplique as alterações selecionadas a este inventário (as exclusões nunca são selecionadas por padrão)',
    publish:
      'As alterações são salvas como rascunho: teste o formulário e publique o inventário para torná-las efetivas',
  },
  fileTooLarge:
    'O arquivo selecionado é grande demais (máx. {{maxSize}} MB): exporte o inventário sem dados, os registros e seus arquivos não são necessários para comparar inventários',
  selectNewSource: 'Selecionar uma nova origem',
  selectNewSourceInfo: 'Descartar esta comparação e selecionar outro arquivo de inventário ou outro inventário',
  refreshComparison: 'Atualizar comparação',
  refreshComparisonInfo:
    'Comparar novamente o mesmo arquivo com a versão atual deste inventário (por ex. depois de editá-lo)',
  sourceSurvey: 'Inventário comparado: {{name}}',
  compareWithSurvey: 'Ou compare com outro inventário deste servidor:',
  fingerprint: {
    thisSurvey: 'Este inventário',
    comparedSurvey: 'Inventário comparado',
    equal: 'Igual a este inventário',
    different: 'Diferente deste inventário',
    label: 'Impressão digital',
    structural: 'estrutural',
    info: 'Impressões digitais da definição do inventário (rascunho). Impressões iguais significam definições iguais. A primeira inclui os identificadores internos: é igual apenas para cópias do mesmo inventário (por ex. exportado e importado em outro servidor). A estrutural usa nomes e códigos: é igual também para inventários criados separadamente com a mesma estrutura. Nomes, rótulos, identificadores, datas e estado de publicação não fazem parte dela.',
    copy: 'Copiar a impressão digital completa: {{value}}',
    copied: 'Impressão digital copiada para a área de transferência',
  },
  identical: 'Os inventários são idênticos',
  counts: '{{added}} somente no inventário comparado, {{changed}} alterados, {{removed}} somente neste inventário',
  surveyInfoChanged:
    'As informações do inventário (idiomas, ciclos, rótulos) são diferentes: veja a aba "Informações do inventário"',
  onlyDifferences: 'Mostrar somente as diferenças',
  hideLayoutOnly: 'Ocultar diferenças apenas de layout',
  apply: 'Aplicar as alterações selecionadas ({{count}})',
  applyConfirm: `Aplicar {{count}} alterações selecionadas a este inventário?
As alterações são salvas como rascunho: chegarão aos registros somente quando o inventário for publicado.`,
  willBeDeleted: 'será eliminado',
  removedNodeDefInfo:
    'Esta definição de nó existe apenas neste inventário: aplicar esta alteração elimina-a (juntamente com os seus descendentes) deste inventário.',
  removedItemInfo: 'Apenas neste inventário: aplicar esta alteração elimina-o deste inventário.',
  applyConfirmWithDeletionsHeader: 'Confirmar as eliminações',
  applyConfirmWithDeletions:
    'Aplicar {{count}} alterações selecionadas a este inventário?\n\n**{{deletionsCount}} delas eliminam elementos deste inventário** (elementos que não estão no inventário comparado):\n\n{{- deletions}}\n\n$t(common.cantUndoWarning)',
  applyWithDeletions: 'Aplicar e eliminar',
  confirmSurveyName: 'Introduza o nome deste inventário para confirmar:',
  deletionOfItemsOf: 'elementos apenas neste inventário de **{{name}}**',
  moreDeletions: '... e mais {{count}}',
  applyCompleted:
    'Alterações aplicadas: {{applied}}, ignoradas: {{skipped}}. Publique o inventário para torná-las efetivas.',
  tabs: {
    nodeDefs: 'Definições de nós',
    categories: 'Categorias',
    taxonomies: 'Taxonomias',
    surveyInfo: 'Informações do inventário',
    surveyFiles: 'Arquivos',
  },
  status: {
    added: 'Somente no inventário comparado',
    changed: 'Alterado',
    removed: 'Somente neste inventário',
  },
  statusLabel: 'Situação',
  matchedBy: {
    uuid: 'Correspondência por identificador interno',
    name: 'Correspondência por nome (os identificadores internos são diferentes)',
    manual: 'Correspondência manual: aplicada como renomeação',
  },
  renameCandidate: 'Pode ser "{{name}}" deste inventário, renomeado',
  possibleRename: 'possível renomeação',
  matchAsRename: 'Corresponder como renomeado',
  unmatch: 'Desfazer correspondência',
  props: {
    branding: 'Identidade visual',
    columnsNo: 'Colunas',
    columnsOrder: 'Ordem das colunas',
    cycles: 'Ciclos',
    defaultCycleKey: 'Ciclo padrão',
    descriptions: 'Descrições',
    extra: 'Propriedades extras',
    family: 'Família',
    fieldManualLinks: 'Links do manual de campo',
    formLayout: 'Layout do formulário',
    genus: 'Gênero',
    gridPosition: 'linha {{row}}, coluna {{column}}, largura {{width}}, altura {{height}}',
    itemExtraDef: 'Propriedades adicionais',
    keepNonApplicableValues: 'Manter os valores não relevantes',
    labels: 'Rótulos',
    languages: 'Idiomas',
    layout: 'Layout',
    levels: 'Níveis',
    messages: 'Mensagens',
    pagesOrder: 'Ordem das páginas',
    parent: 'Entidade pai',
    preloadedMapLayersEnabled: 'Camadas de mapa pré-carregadas habilitadas',
    reportingData: 'Dados de reporte',
    sampleBasedImageInterpretationEnabled: 'Interpretação de imagem baseada em amostra',
    samplingPolygon: 'Polígono amostral',
    scientificName: 'Nome científico',
    size: 'Tamanho',
    srs: 'Sistemas de referência espacial',
    surveyDocOptions: 'Opções da documentação do inventário',
    userExtraPropDefs: 'Propriedades extras do usuário',
    validations: 'Validações',
    vernacularLanguageCodes: 'Idiomas dos nomes vernaculares',
    vernacularNames: 'Nomes vernaculares',
  },
  fileTypes: {
    preloadedMapLayer: 'Camada de mapa pré-carregada',
    surveyDocImage: 'Imagem da documentação do inventário',
    brandingSurveyLogo1: 'Logotipo do inventário 1',
    brandingSurveyLogo2: 'Logotipo do inventário 2',
    brandingSurveyLogo3: 'Logotipo do inventário 3',
    brandingLandingBackground: 'Fundo da página inicial',
  },
  cycle: 'ciclo {{cycle}}',
  property: 'Propriedade',
  sourceValue: 'Inventário comparado',
  targetValue: 'Este inventário',
  emptyValue: '(vazio)',
  layoutOnly: 'somente layout',
  selectItem: 'Selecione um item para ver os detalhes',
  noDifferences: 'Nenhuma diferença',
  identicalItem: 'Nenhuma diferença',
  dependsOn: 'Aplicado junto com:',
  itemsCount: 'itens: {{added}} adicionados, {{changed}} alterados, {{removed}} somente neste inventário',
  itemCode: 'Código',
  taxaCount: 'táxons: {{added}} adicionados, {{changed}} alterados, {{removed}} somente neste inventário',
  taxonCode: 'Código',
  changes: 'Alterações',
  moreItems: '... e mais {{count}} itens',
  categoryRemoval: 'Excluir os itens (e níveis) presentes somente neste inventário',
  taxonomyRemoval: 'Excluir os táxons e nomes vernaculares presentes somente neste inventário',
  removalSelected: 'exclusão selecionada',
  publishedKept: '(publicados: mantidos)',
  reasons: {
    categoryInUse: 'A categoria é usada por definições de nós que não são excluídas',
    categoryMissing: 'A categoria não existe neste inventário',
    cycleMissing: 'Falta um ciclo neste inventário',
    dependencyNotApplicable: 'Uma alteração da qual depende não pode ser aplicada',
    parentMissing: 'A definição de nó pai não existe neste inventário',
    publishedCategoryChanged: 'A categoria de uma definição de nó publicada não pode ser alterada',
    publishedKeyChanged: 'A propriedade "chave" de uma definição de nó publicada não pode ser alterada',
    publishedMoveNotSupported: 'Uma definição de nó publicada não pode ser movida para outra entidade',
    publishedMultipleChanged: 'A propriedade "múltiplo" de uma definição de nó publicada não pode ser alterada',
    publishedTaxonomyChanged: 'A taxonomia de uma definição de nó publicada não pode ser alterada',
    publishedTypeChanged: 'O tipo de uma definição de nó publicada não pode ser alterado',
    taxonomyInUse: 'A taxonomia é usada por definições de nós que não são excluídas',
    taxonomyMissing: 'A taxonomia não existe neste inventário',
    nodeDefUsedByOthers: 'Outras definições de nós a usam em suas expressões: atualize-as também',
    publishedCategoryItemsKept: 'Os itens publicados não podem ser excluídos: eles são mantidos',
    publishedCategoryLevelsKept: 'Os níveis publicados não podem ser excluídos: eles são mantidos',
    publishedCyclesRemoved: 'Remover ciclos de uma definição de nó publicada exclui seus dados nesses ciclos',
    publishedLanguagesRemoved: 'Remover idiomas exclui seus rótulos quando o inventário for publicado',
    publishedNameChanged:
      'Renomeação de uma definição de nó publicada: as expressões que usam o nome antigo devem ser atualizadas',
    publishedNodeDefDeleted:
      'A definição de nó está publicada: seus dados serão excluídos quando o inventário for publicado',
    publishedSurveyCyclesRemoved: 'Remover ciclos exclui seus registros quando o inventário for publicado',
    publishedTaxaKept: 'Os táxons publicados não podem ser excluídos: eles são mantidos',
    publishedVernacularNamesKept: 'Os nomes vernaculares publicados não podem ser excluídos: eles são mantidos',
  },
}
